import { render, staticRenderFns } from "./veJkyResourceEdit.vue?vue&type=template&id=20923b59&scoped=true"
import script from "./veJkyResourceEdit.vue?vue&type=script&lang=js"
export * from "./veJkyResourceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20923b59",
  null
  
)

export default component.exports